import { render, staticRenderFns } from "./clear.vue?vue&type=template&id=53e935df&scoped=true&"
import script from "./clear.vue?vue&type=script&lang=js&"
export * from "./clear.vue?vue&type=script&lang=js&"
import style0 from "./clear.vue?vue&type=style&index=0&id=53e935df&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e935df",
  null
  
)

export default component.exports